import { HeaderPage, DataTable } from './components';
import { cn } from '@/lib/utils';
import { useAccountingUsers } from './hooks';


export const AccountingUsersPage = () => {

    const accountingUsersData = useAccountingUsers();

    return (
        <div className={cn(
            'flex flex-col space-y-3 pb-20',
            'animate__animated animate__fadeIn'
        )}>
            <HeaderPage
                onCreate={accountingUsersData.createAccountingUser}
                isLoading={accountingUsersData.isLoading || accountingUsersData.isFetching} />
            <DataTable
                accountingUsers={accountingUsersData.accountingUsers}
                isLoading={accountingUsersData.isLoading}
                isFetching={accountingUsersData.isFetching}
                data={accountingUsersData.data}
                onDelete={accountingUsersData.deleteAccountingUser}
                onEdit={accountingUsersData.edit}
                onSeeDetails={accountingUsersData.seeDetails}
            />
        </div>
    );
};

export default AccountingUsersPage;
